import React from "react";
import { useSelector } from "react-redux";
import { SectionToggleWrapper } from "./SectionToggleWrapper";
import { DataPoints } from "./DataPoints";
import BiAxialLineChart from "../../../../components/charts/biAxialLineChart/biAxialLineChart";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import FutureDataToggle from "./FutureDataToggle";
import NoData from "../../../../components/noData/noData";
import { NO_FUTURE_DATA_MESSAGE } from "../../../../app_constants";

const SalesAndAttendanceSection = ({ clientCharts, isLoading }) => {
  const {
    currentUser: { currencySymbol }
  } = useSelector((state) => state.clientProfileModule);

  const hasTableData = clientCharts?.tableData?.tableInfo?.data?.length > 0;

  return (
    <SectionToggleWrapper
      title="Sales and Attendance Data"
      idForConfigurator="salesandattendancedata"
      isLoading={isLoading}
    >
      <div className="client-info-bottom chart">
        <div className="cell">
          <BiAxialLineChart chartData={clientCharts} />
        </div>
      </div>

      <FutureDataToggle
        label="Show Future 3 Months"
        cssKey="future-attendance"
        data={clientCharts?.futureTableData}
        currencySymbol={currencySymbol}
        noDataMessage={NO_FUTURE_DATA_MESSAGE}
        filterName="Future Sales"
        fileName="sales-attendance-future"
        tableWrapperId="sales-attendance-future"
        dataPointsClassName="sales-attendance-data-points"
      />

      {hasTableData ? (
        <>
          <div className="sales-attendance-data-points">
            <DataPoints
              dataPoints={clientCharts.tableData.dataPoints}
              currencySymbol={currencySymbol}
            />
          </div>
          <TableWithCustomSearch
            data={clientCharts.tableData.tableInfo.data}
            colHeaders={clientCharts.tableData.tableInfo.colHeaders}
            columns={clientCharts.tableData.tableInfo.columns}
            showCount={false}
            tableWrapperId="sales-attendance-breakdown"
            fileName="sales-attendance-breakdown"
          />
        </>
      ) : (
        <NoData />
      )}
    </SectionToggleWrapper>
  );
};

export default SalesAndAttendanceSection;
